import SEOHead from '@components/SEOHead';
import Header from '@components/layout/Header';
import { MainSection } from '@components/LandingElements/MainSection';
import React from 'react';
import { Footer } from '@components/layout/Footer';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { SimpleFaq } from '@components/LandingElements/SimpleFAQ';
import { CtaBtn } from '@components/LandingElements/CtaBtn';
import { FeatureRightImgSection } from '@components/LandingElements/FeatureSection/FeatureRightImgSection';
import { FeatureLeftImgSection } from '@components/LandingElements/FeatureSection';
import Link from 'next/link';

export default function AiMilf() {
  const faqContent = [
    {
      question: 'Who is AI Milf?',
      answer:
        'AI Milf represents a mature, beautiful woman characterized within various fantasy scenarios. For example, you might encounter "Mom\'s Friend," a scenario where a woman visits your apartment unexpectedly while you\'re in the shower, or a "Landlord" scenario, where she raises your rent compelling you to pay her a visit.',
    },
    {
      question: 'Is AI Milf interaction realistic?',
      answer:
        'Yes, our advanced artificial intelligence provides realistic and engaging interactions, simulating conversations and scenarios with a mature Milf AI.',
    },
    {
      question: 'Can I generate AI images?',
      answer:
        'Yes, you can generate AI images with any character that has a photo content tag, and any AI girlfriend you create will support AI image content.',
    },
    {
      question: 'How private are my interactions with AI Milf?',
      answer:
        'Your interactions with AI Milf are completely private. We prioritize user confidentiality and data security, ensuring that your conversations and information are securely protected.',
    },
    {
      question: 'Are there any age restrictions for using the Milf AI service?',
      answer:
        'Yes, you must be at least 18 years old to use the AI generated milf service. We adhere strictly to legal age restrictions to ensure responsible use of our platform.',
    },
    {
      question: 'What other AI roleplay scenarios do you offer?',
      answer:
        'We offer over 100 scenarios ranging from casual to extreme. Examples include a cat girl who barely speaks, a slave girl from the 18th century, or a nurse who greets you at the hospital. The choice is yours, allowing you to dive into diverse and immersive roleplay experiences.',
    },
  ];
  return (
    <>
      <SEOHead
        title="AI Milf - Spicy Chat AI with Images"
        description="Roleplay with mature woman in our spicy AI chat, genereate and customize images. Meet your desired AI Milf now!"
        type="website"
        keywords="ai milf, milf ai, ai generated milf, talk to ai milf, ai milf chat"
        url="https://www.aigirlfriend.wtf/ai-milf"
        imageUrl="https://www.aigirlfriend.wtf/web-banner-min.jpg"
      />
      <Header />
      <main>
        <MainSection
          title={
            <>
              The Best Sexy{' '}
              <span className="!leading-none text-wtf-persianRed">
                <br />
                AI Milf
                <br />
              </span>
            </>
          }
          subTitle={'Are you looking for mature woman roleplay?'}
          mainText={
            'Meet your perfect mature AI Milf for spicy chats, nude images, or even create your own girlfriend.'
          }
          imgSrc={'/sections/ai-milf/milf.jpeg'}
          imgSrcMobile={'/sections/ai-milf/milf.jpeg'}
          ctaLink={'/ai-girls'}
          ctaText={'Try Free'}
        />
        <FeatureLeftImgSection
          redTitle={'Crazy roleplay AI chat'}
          sectionTitle={'Spicy Chat with AI Milf'}
          imgSrc={'/sections/ai-milf/milf2.jpeg'}
          imgAlt={'Anime ai girl with fox ears'}
          textStructure={
            <>
              <p className={'text-xs'}>
                Experience the full range of desires that a mature woman can
                feel. Unveil AI milf fantasies and become her lover. In this
                chat, everything is possible; your actions decide the story, so
                craft it!
              </p>
            </>
          }
        />
        <div className="text-center">
          <CtaBtn href={'/ai-girls'} text={'Try Free'} />
        </div>
        <FeatureRightImgSection
          title={'Extensive Catalog of AI Girls'}
          imgSrc={'/sections/ai-milf/milf3.jpeg'}
          imgAlt={'AI girl in dress on sport field'}
          textStructure={
            <p>
              Try out different fantasy scenarios with all kinds of AI girls.
              Browse through our catalog of AI characters and dive into chat AI
              roleplay not only with AI milf but also with lovely coworkers,
              bullies, and shy cuties!
            </p>
          }
        />
        <br />
        <br />
        <br />
        <SimpleFaq
          content={faqContent}
          ctaText={'Try Free'}
          ctaLink={'/ai-girls'}
        />
      </main>
      <Footer />
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['header', 'footer'])),
    },
  };
}
